/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UrlaubsanspruchDto } from '../../models/urlaubsanspruch-dto';

export interface GetBeanspruchteUrlaubeForMitarbeiter$Json$Params {

/**
 * ID des Mitarbeiters für den die Urlaube geholt werden sollen
 */
  mitarbeiterId: string;

/**
 * Jahr für den die Urlaube geholt werden sollen
 */
  year: number;
}

export function getBeanspruchteUrlaubeForMitarbeiter$Json(http: HttpClient, rootUrl: string, params: GetBeanspruchteUrlaubeForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UrlaubsanspruchDto>>> {
  const rb = new RequestBuilder(rootUrl, getBeanspruchteUrlaubeForMitarbeiter$Json.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.path('year', params.year, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UrlaubsanspruchDto>>;
    })
  );
}

getBeanspruchteUrlaubeForMitarbeiter$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/beanspruchteurlaube/{year}';
